module.exports = __webpack_public_path__ + "static/media/19import-45-old.9d20f82c.xlsx";